import React from 'react';
import { useScrollAnimation } from '../../../../hooks/useScrollAnimation';
import './IdeasAreCommodities.scss';

const IdeasAreCommodities = () => {
  const { ref: quoteRef, isVisible: quoteVisible } = useScrollAnimation();
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollAnimation();

  const cards = [
    {
      id: 1,
      title: "Specialists on Demand",
      description: "Access the right skills exactly when your project needs them",
      color: "light-blue"
    },
    {
      id: 2,
      title: "Agility That Wins",
      description: "Scale up or down quickly to match your business goals.",
      color: "light-orange"
    },
    {
      id: 3,
      title: "Faster Start, Faster Finish",
      description: "Skip slow hiring cycles and get projects delivered on time.",
      color: "light-yellow"
    },
    {
      id: 4,
      title: "Pay for Results",
      description: "Get expert work without overhead costs or long commitments.",
      color: "light-green"
    }
  ];

  return (
    <section className='ideas-are-commodities'>
      <div className='ideas-container'>
        {/* Quote Section */}
        <div 
          ref={quoteRef as React.RefObject<HTMLDivElement>} 
          className='quote-section' 
          style={{display: 'flex', flexDirection: 'column', justifyContent:'space-evenly'}}
        >
          <blockquote className={`quote-text ${quoteVisible ? 'visible' : ''}`}>
            " Ideas are commodities, but execution is not! "<br />
          </blockquote>
          <blockquote className={`quote-text-sub ${quoteVisible ? 'visible' : ''}`} style={{alignSelf:'flex-end'}}>- Michael Dell</blockquote>
          <p className={`description-text ${quoteVisible ? 'visible' : ''}`}>
            While many dream, only a bold few take action—because real success belongs to those who execute. Let your idea come to life by hiring freelancers on demand for short or long project.
          </p>
        </div>

        {/* Cards Section */}
        <div ref={cardsRef as React.RefObject<HTMLDivElement>} className='cards-section'>
          {cards.map((card, index) => (
            <div 
              key={card.id}
              className={`card ${card.color} ${cardsVisible ? 'visible' : ''}`}
            >
              <h3 className='card-title'>{card.title}</h3>
              <p className='card-description'>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IdeasAreCommodities;
